import { useContext } from "react";
import { default as CustomErrorResult } from "src/pages/Link/Products/ConnectAccount/ConnectStep/components/ErrorResult";

import ErrorResult from "../../Demo/sections/components/ErrorResult";
import Context from "../../Products/context";

// ----------------------------------------------------------------------

type Props = {
	errorMessage: string;
};

export const DErrorResult = ({ errorMessage }: Props) => {
	const { theme } = useContext(Context);

	const hasTheme = theme !== undefined;

	return hasTheme ? (
		<CustomErrorResult errorMessage={errorMessage} />
	) : (
		<ErrorResult errorMessage={errorMessage} />
	);
};

export default DErrorResult;
